export default "<p>admin-users works!</p>\n";